import { flatMap, get, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Employees {
  employersData: object;
  contactDetailData: object;
  curEmployerEditData: any;
  totalPageCount: number;
  totalData: number;
  error: string;
  isImportSuccess: boolean;
}

const initialArgs: Employees = {
  employersData: [],
  contactDetailData: [],
  curEmployerEditData: {},
  totalPageCount: 0,
  totalData: 17,
  error: "",
  isImportSuccess: false,
};

const reducer = (state: Employees, action: Employees) => {
  return { ...state, ...action };
};

const useEmployers = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getEmployers = async (
    page: string,
    listPerPage: string,
    searchText: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/v1/users/get?role=Employer&page=${page}&listPerPage=${listPerPage}&search=${searchText}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          employersData: result.data.data.data,
          totalPageCount: get(result, "data.data.totalPageCount", 0),
          totalData: get(result, "data.data.totalData", 0),
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const createEmployer = async (param: any) => {
    const paramObj = {
      ...param,
      role: "Employer",
      // password: process.env.COMMAN_PASSWORD
      //   ? process.env.COMMAN_PASSWORD
      //   : "Admin@123",
    };

    let createPagesToast;
    try {
      const result: any = await api.post("/api/v1/users/register", paramObj, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (result.data.status) {
        createPagesToast = toast.success(result.data.message, {
          id: createPagesToast,
        });
        //toast.dismiss(createPagesToast);
        setState({ ...state, employersData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: createPagesToast });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: createPagesToast });
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateEmployer = async (id: string, param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.post(
        `/api/v1/users/update/${id}`,
        paramObj,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (result.data.status) {
        toast.success(result.data.message, {
          id: "updateEmployerToastError",
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: "updateEmployerToastError" });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: "updateEmployerToastError" });
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getContactDetail = async (
    page: string,
    listPerPage: string,
    searchText: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/v1/users/contactDetail?page=${page}&listPerPage=${listPerPage}&search=${searchText}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          contactDetailData: result.data.data.data,
          totalPageCount: get(result, "data.data.totalPageCount", 0),
          totalData: get(result, "data.data.totalData", 0),
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const editEmployer = async (userId: string) => {
    try {
      const result: any = await api.get(
        `/api/v1/users/findOne?userId=${userId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          curEmployerEditData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const importEmployer = async (param: any) => {
    const paramObj = {
      file: param.files,
    };
    let resetImportToast;
    setState({ ...state, isImportSuccess: false });

    try {
      const result: any = await api.post(
        "/api/v1/users/employerImport",
        paramObj,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (result.data.status) {
        resetImportToast = toast.success(result.data.message, {
          id: resetImportToast,
        });
        setState({ ...state, isImportSuccess: true });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: resetImportToast });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: resetImportToast });
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateState = (payload: any) => {
    setState({ ...state, ...payload });
  };

  return {
    getEmployers,
    createEmployer,
    updateEmployer,
    getContactDetail,
    editEmployer,
    importEmployer,
    updateState,
    ...state,
  };
};

export default useEmployers;
